import * as stylex from '@stylexjs/stylex'
import { useState } from 'react'
import Dialog from './Dialog'
import Icon, { type IconName } from './Icon'
import type { CreatePersonInput, Person } from '../lib/ledger'


const styles = stylex.create({
  s0: {
    display: "flex",
    flexDirection: "column",
    rowGap: "20px",
  },
  s1: {
    display: "block",
  },
  s2: {
    marginBottom: "8px",
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
  },
  s3: {
    height: "44px",
    width: "100%",
    borderRadius: "0.75rem",
    borderWidth: 1,
    borderColor: "#dbe2d9",
    paddingInline: "12px",
    fontSize: "13px",
  },
  s4: {
    display: "grid",
    gap: "16px",
    "@media (min-width: 640px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
  },
  s5: {
    borderRadius: "0.75rem",
    backgroundColor: "#fff3ed",
    paddingInline: "12px",
    paddingBlock: "8px",
    fontSize: "12px",
    color: "#9b491e",
  },
  s6: {
    display: "flex",
    justifyContent: "end",
    gap: "12px",
    borderTopWidth: 1,
    borderColor: "#e8ece7",
    paddingTop: "20px",
  },
  s7: {
    height: "40px",
    borderRadius: "0.75rem",
    paddingInline: "16px",
    fontSize: "13px",
  },
  s8: {
    height: "40px",
    borderRadius: "0.75rem",
    backgroundColor: "#408b56",
    paddingInline: "20px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#fff",
  },
  s9: {
    marginLeft: "8px",
    display: "inline",
    height: "16px",
    width: "16px",
  },
})
const icons: Array<{ name: IconName; label: string }> = [
  { name: 'people', label: 'Person' }, { name: 'food', label: 'Food' }, { name: 'travel', label: 'Travel' },
  { name: 'shopping', label: 'Shopping' }, { name: 'gift', label: 'Gift' }, { name: 'receipt', label: 'Other' },
]

export default function EditPersonDialog({ person, onClose, onSave }: { person: Person; onClose: () => void; onSave: (input: CreatePersonInput) => Promise<void> }) {
  const [name, setName] = useState(person.name)
  const [email, setEmail] = useState(person.email ?? '')
  const [phone, setPhone] = useState(person.phone ?? '')
  const [avatar, setAvatar] = useState<IconName>((person.avatar as IconName) || 'people')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  async function submit(event: React.FormEvent) { event.preventDefault(); if (!name.trim()) { setError('Name is required.'); return } setSaving(true); setError(''); try { await onSave({ displayName: name.trim(), email: email.trim(), phone: phone.trim(), avatar }) } catch (reason) { setError(reason instanceof Error ? reason.message : 'Could not update this person.'); setSaving(false) } }
  return <Dialog description="Keep this person's details up to date." onClose={saving ? () => undefined : onClose} title="Person details"><form {...stylex.props(styles.s0)} onSubmit={submit}><label {...stylex.props(styles.s1)}><span {...stylex.props(styles.s2)}>Full name</span><input autoFocus {...stylex.props(styles.s3)} onChange={(e) => setName(e.target.value)} value={name} /></label><div {...stylex.props(styles.s4)}><label {...stylex.props(styles.s1)}><span {...stylex.props(styles.s2)}>Email</span><input {...stylex.props(styles.s3)} onChange={(e) => setEmail(e.target.value)} type="email" value={email} /></label><label {...stylex.props(styles.s1)}><span {...stylex.props(styles.s2)}>Phone</span><input {...stylex.props(styles.s3)} onChange={(e) => setPhone(e.target.value)} value={phone} /></label></div><label {...stylex.props(styles.s1)}><span {...stylex.props(styles.s2)}>Icon</span><select {...stylex.props(styles.s3)} onChange={(e) => setAvatar(e.target.value as IconName)} value={avatar}>{icons.map((item) => <option key={item.name} value={item.name}>{item.label}</option>)}</select></label>{error && <p {...stylex.props(styles.s5)}>{error}</p>}<div {...stylex.props(styles.s6)}><button {...stylex.props(styles.s7)} onClick={onClose} type="button">Cancel</button><button {...stylex.props(styles.s8)} disabled={saving} type="submit">{saving ? 'Saving…' : 'Save changes'}<Icon {...stylex.props(styles.s9)} name="check" /></button></div></form></Dialog>
}
